import * as React from "react";

const RiverStar = ({
    pathFill = "#fff",
    ...props
}: React.SVGProps<SVGSVGElement> & {
    pathFill?: string;
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={8}
        height={8}
        fill="none"
        {...props}
    >
        <path
            fill={pathFill}
            d="M7.072 1.208 8 2.792 4.778 4 8 5.262l-.928 1.53-2.676-2.148L4.915 8H3.113l.491-3.356L.928 6.792 0 5.262 3.25 4 0 2.792l.928-1.584 2.676 2.148L3.113 0h1.802l-.52 3.329 2.677-2.121Z"
        />
    </svg>
);
export default RiverStar;
